import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorParserService {

  constructor() { }

  parseError(errors) {
    if (!errors) {
      return null;
    }
    const errorsIDs = [];
    if (errors.graphQLErrors) {
      errorsIDs.push(...errors.graphQLErrors.map(({ id }) => id));
    }
    if (errors.networkError && errors.networkError.error && errorsIDs) {
      errorsIDs.push(...errors.networkError.error.errors.map(({ id }) => id));
    }
    if (!errorsIDs.length) {
      return null;
    }
    console.log(errorsIDs);
    
    return (`${errorsIDs[0]}${(errorsIDs.length > 1) ? (' - ' + errorsIDs[errorsIDs.length - 1]) : ''}`);
  }

  isDislikedForVenue(errors): boolean {
    return !!(errors && errors.graphQLErrors || []).find(
      (err) => err.extensions && err.extensions.code === 'TRACK_DISLIKED_FOR_VENUE'
    );
  }

  describe(errors): string {
    if (this.isDislikedForVenue(errors)) {
      return 'This track is disliked at this venue, so it will not play in any of its zones.';
    }
    const errIdStr = this.parseError(errors);
    return `Oops, something went wrong. Please try again.${errIdStr ? ' Error id: ' + errIdStr : ''}`;
  }
}
